export const invalidateCache = (queryField, options = {}) => (_res, _args, cache) => {
  const key = 'Query';
  cache
    .inspectFields(key)
    .filter((field) => field.fieldName === queryField)
    .forEach((field) => {
      const customField = { ...field };

      if (options.clearCursors) {
        customField.arguments.after = undefined;
        customField.arguments.before = undefined;
      }

      cache.invalidate(key, customField.fieldName, customField.arguments);
    });
};

export const invalidateSingleEntryCache = (typename, argField = 'id') => (_res, args, cache) => {
  cache.invalidate({ __typename: typename, id: args[argField] });
};

/**
 * updateQueryCache
 * @param {fieldName} string is the name of the query whose cache you want to update
 * @param {query} string is the gql tag template literal of the query named above
 * @param {handleCacheUpdate} function receives data (copied) to MUTATE; returns mutated data
*/
export const updateQueryCache = ({ fieldName, query, handleCacheUpdate }) => (_res, _, cache) => {
  const queries = cache
    .inspectFields('Query')
    .filter((field) => field.fieldName === fieldName);
  const lastQueryRan = queries[queries.length - 1];
  if (lastQueryRan) {
    cache.updateQuery(
      { query, variables: lastQueryRan.arguments },
      handleCacheUpdate
    );
  }
};

export const updateAllQueries = ({ fieldName, query }) => (_, args, cache) => {
  cache.inspectFields('Query').forEach((field) => {
    if (field.fieldName === fieldName) {
      cache.updateQuery({ query, variables: field.arguments }, (data) => {
        const newEdges = data[fieldName].edges.filter(
          ({ node }) => node.id !== args.id
        );
        const newData = {
          ...data,
          [fieldName]: {
            ...data[fieldName],
            edges: newEdges,
          },
        };
        return newData;
      });
    }
  });
};
